import React from "react";
import { Link } from "react-router-dom";
import { DoorOpen } from "lucide-react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

export default function AccountDeletedPage() {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50" data-testid="account-deleted-page">
            <NavBar />

            <main className="flex-1">
                <section className="mx-auto max-w-2xl px-4 py-16 sm:py-24">
                    <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
                        <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-crumborange/10 flex items-center justify-center">
                            <DoorOpen className="h-6 w-6 text-crumborange" aria-hidden="true" />
                        </div>
                        <h1 className="text-2xl font-semibold text-crumbblue mb-2" data-testid="deleted-heading">
                            Your account has been deleted
                        </h1>
                        <p className="text-gray-600 mb-6" data-testid="deleted-message">
                            We’re sorry to see you go, but you can create another account whenever you'd like.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-3 justify-center">
                            <Link
                                to="/"
                                className="inline-flex justify-center rounded-xl px-5 py-2.5 border border-gray-300 hover:bg-gray-100"
                                data-testid="home-link"
                            >
                                Return home
                            </Link>
                            <Link
                                to="/signup"
                                className="inline-flex justify-center rounded-xl px-5 py-2.5 bg-crumborange text-white hover:opacity-90"
                                data-testid="signup-link"
                            >
                                Create a new account
                            </Link>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}